/** What the recipient gets: the body as the server trims it, then the opt-out line on its own line. */
export function withSmsOptOutLine(body: string, optOutLine: string): string {
  return `${body.trim()}\n${optOutLine}`;
}

/** The part of a server-rendered text the rescue can edit: everything before its opt-out line. */
export function withoutSmsOptOutLine(text: string, optOutLine: string): string {
  const suffix = `\n${optOutLine}`;
  return text.endsWith(suffix) ? text.slice(0, -suffix.length) : text;
}

// GSM-7 fits 160 characters in one text and 153 in each part of a longer one, and its extension
// characters take two. One character outside it sends the whole text as UCS-2: 70, or 67 per part.
const GSM_BASIC = new Set(
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà',
);
const GSM_EXTENDED = new Set('^{}\\[~]|€');

/** How many texts a message goes out as. */
export function smsSegmentCount(text: string): number {
  const chars = [...text];
  if (chars.every((char) => GSM_BASIC.has(char) || GSM_EXTENDED.has(char))) {
    const units = chars.reduce((sum, char) => sum + (GSM_EXTENDED.has(char) ? 2 : 1), 0);
    return units <= 160 ? 1 : Math.ceil(units / 153);
  }
  // UCS-2 counts UTF-16 code units, so an emoji takes two.
  return text.length <= 70 ? 1 : Math.ceil(text.length / 67);
}
